import styled from "styled-components";

import {
  DATA_E2E_KEY,
  IStyledAttributes,
  LIVE_MAP_STATION_DOT_RADIUS,
} from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

import { STATION_DOT_STROKE_WIDTH_PX } from "./maplibre-marker.constants";

export const MapLibreStationDot = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "maplibre-station-dot",
  className: "maplibre-station-dot",
})<{ $backgroundColor: string; $sizePx?: number }>`
  box-sizing: border-box;
  width: ${({ $sizePx }) => $sizePx ?? LIVE_MAP_STATION_DOT_RADIUS * 2}px;
  height: ${({ $sizePx }) => $sizePx ?? LIVE_MAP_STATION_DOT_RADIUS * 2}px;
  border-radius: 50%;
  border: ${STATION_DOT_STROKE_WIDTH_PX}px solid ${rydeColors.white};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  flex-shrink: 0;
`;
